document.querySelectorAll(".js-load-collection").forEach(el => {
  const url = el.getAttribute("data-collection-url");
  if (!url) return;

  fetch(url)
    .then(response => response.text())
    .then(data => {
      document.querySelectorAll(".js-load-collection").forEach(e => e.remove());

      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = data;
      const collectionContent = tempDiv.querySelector(".js-collection-content");
      if (collectionContent) {
        const target = document.querySelector(".js-load-collection-content");
        if (target) {
          target.insertAdjacentHTML("beforeend", collectionContent.innerHTML);
          if (typeof initializeFadeInObserver === 'function') {
            initializeFadeInObserver();
          }
          if (typeof wishlistPage === "function") {
            wishlistPage();
          }
          if (typeof initProductGridItemColors === "function") {
            initProductGridItemColors();
          }
          if (window.collectionScripts) {
            window.collectionScripts.forEach(src => {
              const script = document.createElement('script');
              script.src = src;
              script.async = false; 
              document.body.appendChild(script);
            });
          }
        }
      }
    })
    .catch(err => console.error("Błąd ładowania kolekcji:", err));
});